import { render, staticRenderFns } from "./setting-index.vue?vue&type=template&id=31f2e360&"
import script from "./setting-index.vue?vue&type=script&lang=js&"
export * from "./setting-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports